import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://cxjbuevhijweijyoowvg.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_1gjAadr1ouw0VvTrb6h8Tg_btvgO786';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
